import Slider from './slider.js';
import { wrapLetters } from './helpers.js';


export function recalculateListTransform(list, oldHeight) {
    return oldHeight - list.getBoundingClientRect().height;
}



let namesCache = false;
export function requestNames() {
    return new Promise(async (res)=>{
        const decoder = new TextDecoder();
        const response = await fetch('./themes/ww1/roll_of_honor/names.csv');
        const text = await response.text();

        const numbersReg = /([A-Z]*\/?\d+(?:\/\d+)?\(?[\w]*\)?)$/;
        const names = text.split(/[\n\r]+/g);

        const namesObject = names.map((name)=>{
            if (name === '') { return; }

            /* parse number out */
            let number = '';
            const numberMatch = name.trim().match(numbersReg);
            if (numberMatch) {
                number = numberMatch[0].trim();
            }
            name = name.replace(number, '').trim();
            // name = wrapLetters(name);

            return {
                name,
                number,
            }
        });
        namesCache = namesObject;
        res(namesObject);
    });
}


let currentIndex = 0;
const observer = setupObserver();
const masterList = document.querySelector('.heroes');
export async function populateNames(count = 10, recalculate = false) {
    const names = namesCache || await requestNames();
    let originalHeight;
    if (recalculate) {
        originalHeight = masterList.getBoundingClientRect().height;
    }

    for (let i=0; i < count; i++) {
        if (currentIndex > names.length - 2) { currentIndex = 0; }

        const hero = names[++currentIndex];
        if (!hero) {
            return;
        }
        const li = document.createElement('li');
        li.classList.add('hero')
        li.innerHTML = `<span class="name">${hero.name}</span><span class="number">${hero.number}</span>`;
        observer.observe(li);
        masterList.prepend(li);
    }

    if (recalculate && slider) {
        slider.push(recalculateListTransform(masterList, originalHeight), false);
    }

    return;
}



export function setupObserver() {
    const wrappedClass = 'text-wrapped';
    const observerCallback = (entries)=>{
        entries.forEach((entry)=>{
            if ( entry.isIntersecting ) {
                /* No need to wrap now */
                // const nameEl = entry.target.querySelector('.name');
                // nameEl.innerHTML = wrapLetters(nameEl.innerText);
                entry.target.classList.add(wrappedClass); // Class marks element up for deleting
            } else {
                if (!entry.target.classList.contains(wrappedClass)) return;
                try {
                    masterList.removeChild(entry.target);
                } catch(e) {}
            }
        });
    }

    const observer = new IntersectionObserver((entries)=>{
        window.requestIdleCallback(()=>{observerCallback(entries)}, {
            timeout: 1000,
        });
    });

    const heroEls = document.querySelectorAll('.hero');
    heroEls.forEach(li=>observer.observe(li));

    return observer;
}
window.populateNames = populateNames;

let namesCount = 0;
export default async function importNames(){
    await populateNames();

    const list = masterList;
    const slider = new Slider(list);
    list.style.transition = 'none';
    list.style.transform = 'translateY(0px)';
    slider.goToTop();
    window.slider = slider;

    setTimeout(()=>{
        // list.style.transition = 'transform '+ C.sliderTransitionTime +'ms ease-in-out';
        list.style.transition = 'none';
        slider.next();


        setInterval(()=>{
            if (C.sliderScroll) {
                const addNames = 11 - document.querySelectorAll('.hero').length;
                namesCount += addNames;
                populateNames(addNames, true);
                slider.next();
            }
        }, C.sliderStepTime);

    }, 100);
};



// WEBPACK FOOTER //
// ./roll_of_honor/javascript/importNames.js